<template>
  <div class="operation-logs-container" ref="operation-logs-container" :style="{height:height}">
    <div class="history-content infinite-list" style="display:flex;justify-content: left; padding-top:30px;overflow:auto;margin-left:150px;" v-infinite-scroll="load">
      <el-timeline>
        <el-timeline-item v-for="(activity, index) in historyData" :key="index" :color="activity.color" :timestamp="activity.timeDate">
          <span class="history-content-txt" @click="showOperationDetail(activity.requestId)">{{ activity.message }}</span>
        </el-timeline-item>
      </el-timeline>
      <div class="emty">
        <el-empty :image-size="200" v-if="historyData.length === 0" description="暂无记录"></el-empty>
      </div>
    </div>
    <el-dialog :append-to-body='true' :close-on-click-modal="false" :close-on-press-escape="true" :title='dialog.title' :visible='dialog.visible' :width="dialog.width" @close="destroyComponent" center class="dialog-dynamic-mod">
      <component :newObj="newObj" :oldObj="oldObj" :is="dialog.component" @close="destroyComponent" />
    </el-dialog>
  </div>
</template>
<script>
import { systemApi } from '@/api';
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import { showLoading, hideLoading } from '@/plugins/loading';
import Code from './operationDetail.vue';
import { dialogMixin } from "@/common/mixins/";
export default {
  mixins: [dialogMixin],
  data () {
    return {
      height: '0px',
      pageSize: 20,
      pageNum: 1,
      options: [
        { value: "", label: "全部" },
        { value: "add", label: "增加" },
        { value: "del", label: "删除" },
        { value: "upd", label: "更新" },
        { value: "publish", label: "发布" },
        { value: "oth", label: "其他" },
      ],
      historyData: [],
      canLoading: true,
      oldObj: {},
      newObj: {}
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 懒加载调用日志接口
    async load () {
      if (!this.canLoading) return;
      const parmas = { pageSize: this.pageSize, pageNum: this.pageNum }
      showLoading();
      try {
        const { code, data, message } = await systemApi.getMyOperationLogs(parmas)
        if (code === 200) {
          if (data.count / this.pageSize > this.pageNum) {
            this.pageNum++
          } else {
            this.canLoading = false
          }
          this.historyData.push(...data.rows)
          this.historyData.forEach(item => {
            if (item.userName === this.userInfo.realName) {
              item.color = "#078080";
            }
            item.timeDate = this.formatTime(item.updateTime);
            item.message = `${item.operationType}${item.modelName}(${item.userName})`;
          })
        } else {
          this.canLoading = false
          this.$message.error(message)
        }
      } catch (error) {
        this.canLoading = false
      } finally {
        hideLoading();
      }
    },
    // 获取操作日志详情
    async getOperationLogDetail (requestId) {
      showLoading();
      const { code, data, message } = await systemApi.getOperationLogDetail({ requestId });
      if (code === 200) {
        this.oldObj = JSON.parse(data.oldObj);
        this.newObj = JSON.parse(data.newObj);
      } else {
        this.$message.error(message);
      }
      hideLoading();
    },
    async showOperationDetail (requestId) {
      await this.getOperationLogDetail(requestId);
      this.setDialog(true, "修改记录详情", Code, "900px", "8vh");
    },
    // 销毁动态组件
    destroyComponent () {
      this.setDialog(false, "", null, "1100px", "1vh");
    },
  },
  mounted () {
    const height = document.body.offsetHeight - 250;
    this.height = height + "px";
  }
};
</script>
<style lang="less">
.operation-logs-container {
  .hisotry-form {
    display: flex;
    align-items: center;
  }
  .el-timeline-item__timestamp.is-bottom {
    position: absolute;
    left: -140px;
    top: -7px;
    color: #333;
  }
  .el-timeline {
    padding-left: 180px;
  }
  .history-content {
    height: calc(100% - 50px);
    .history-content-txt {
      cursor: pointer;
    }
  }
  .emty {
    margin-top: 168px;
    .el-empty__description {
      display: none;
    }
  }
}
</style>